(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
        button: this.querySelector('[data-localization-button]'),
        panel: this.querySelector('[data-localization-panel]'),
        search: this.querySelector('[data-country-search-input]'),
        searchStatus: this.querySelector('[data-country-search-status]'),
        emptyState: this.querySelector('[data-country-empty]'),
        current: this.querySelector('[data-localization-current]'),
        backdrop: this.querySelector('[data-localization-backdrop]'),
        close: this.querySelector('[data-localization-close]'),
        countryList: this.querySelector('.localization-country-list'),
      };
      this.form = this.querySelector('form');
      this.isSubmitting = false;
      this.panelPositionFrame = null;
      this.boundOnDocumentPointerDown = this.onDocumentPointerDown.bind(this);
      this.boundSchedulePanelPosition = this.schedulePanelPosition.bind(this);
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.elements.panel.addEventListener('keydown', this.onPanelKeyDown.bind(this));
      document.addEventListener('pointerdown', this.boundOnDocumentPointerDown, true);

      if (this.elements.backdrop) {
        this.elements.backdrop.addEventListener('click', () => {
          this.hidePanel();
          this.elements.button.focus({ preventScroll: true });
        });
      }

      if (this.elements.close) {
        this.elements.close.addEventListener('click', () => {
          this.hidePanel();
          this.elements.button.focus({ preventScroll: true });
        });
      }

      if (this.elements.search) {
        this.elements.search.addEventListener('input', this.filterCountries.bind(this));
        this.elements.search.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') event.preventDefault();
        });
      }

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    normalizeSearchValue(value) {
      return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLocaleLowerCase()
        .trim();
    }

    filterCountries() {
      if (!this.elements.search) return;

      const query = this.normalizeSearchValue(this.elements.search.value);
      const countries = Array.from(this.querySelectorAll('[data-country-option]'));
      const matches = [];
      let visibleCount = 0;

      countries.forEach((country) => {
        const countryName = this.normalizeSearchValue(country.dataset.countryName || '');
        const countryCode = this.normalizeSearchValue(country.dataset.countryCode || '');
        const currencyCode = this.normalizeSearchValue(country.dataset.currencyCode || '');
        const currencySymbol = this.normalizeSearchValue(country.dataset.currencySymbol || '');
        const isCountryCode = query !== '' && countryCode === query;
        const isCurrencyCode = query !== '' && currencyCode === query;
        const startsWithName = query !== '' && countryName.startsWith(query);
        const containsName = query !== '' && countryName.includes(query);
        const isCurrencySymbol = query !== '' && currencySymbol === query;
        const isMatch = query === ''
          || isCountryCode
          || isCurrencyCode
          || containsName
          || isCurrencySymbol;

        country.toggleAttribute('hidden', !isMatch);
        if (!isMatch) return;

        let rank = 5;
        if (query === '' || isCountryCode) rank = 0;
        else if (isCurrencyCode) rank = 1;
        else if (startsWithName) rank = 2;
        else if (containsName) rank = 3;
        else if (isCurrencySymbol) rank = 4;

        matches.push({
          country,
          rank,
          index: Number.parseInt(country.dataset.countryIndex || '0', 10),
        });
        visibleCount += 1;
      });

      if (this.elements.countryList) {
        matches
          .sort((first, second) => first.rank - second.rank || first.index - second.index)
          .forEach(({ country }) => this.elements.countryList.insertBefore(country, this.elements.emptyState));
      }

      if (this.elements.emptyState) {
        this.elements.emptyState.toggleAttribute('hidden', visibleCount !== 0);
      }

      if (this.elements.searchStatus) {
        this.elements.searchStatus.textContent = visibleCount === 1 ? '1 result' : `${visibleCount} results`;
      }
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
      this.elements.panel.removeAttribute('role');
      this.elements.panel.removeAttribute('aria-modal');
      document.body.classList.remove('localization-picker-open');
      this.stopPanelPositionTracking();

      if (this.elements.backdrop) {
        this.elements.backdrop.setAttribute('hidden', true);
      }

      if (this.elements.search) {
        this.elements.search.value = '';
        this.filterCountries();
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus({ preventScroll: true });
    }

    onItemClick(event) {
      event.preventDefault();
      if (this.isSubmitting || !this.form || !this.elements.input) return;

      const item = event.currentTarget;
      const value = item.dataset.value;
      if (!value) return;

      const isCurrentValue = this.elements.input.value === value;
      this.elements.input.value = value;

      if (this.elements.current && item.dataset.label) {
        this.elements.current.textContent = item.dataset.label;
      }

      this.querySelectorAll('[data-value]').forEach((option) => {
        const isSelected = option === item;
        option.classList.toggle('disclosure__link--active', isSelected);
        if (isSelected) {
          option.setAttribute('aria-current', 'true');
        } else {
          option.removeAttribute('aria-current');
        }
      });

      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }

      this.hidePanel();

      if (isCurrentValue) {
        this.elements.button.focus({ preventScroll: true });
        return;
      }

      this.isSubmitting = true;
      this.elements.button.setAttribute('aria-busy', 'true');
      this.elements.button.setAttribute('aria-disabled', 'true');

      requestAnimationFrame(() => {
        try {
          HTMLFormElement.prototype.submit.call(this.form);
        } catch (error) {
          this.isSubmitting = false;
          this.elements.button.removeAttribute('aria-busy');
          this.elements.button.removeAttribute('aria-disabled');
        }
      });
    }

    openSelector() {
      if (this.isSubmitting) return;

      const shouldOpen = this.elements.panel.hasAttribute('hidden');

      if (!shouldOpen) {
        this.hidePanel();
        return;
      }

      this.elements.panel.removeAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', 'true');

      if (this.isMobileCountrySelector()) {
        this.elements.panel.setAttribute('role', 'dialog');
        this.elements.panel.setAttribute('aria-modal', 'true');
        document.body.classList.add('localization-picker-open');
      }

      if (this.elements.search) {
        this.elements.search.value = '';
        this.filterCountries();
        this.startPanelPositionTracking();

        requestAnimationFrame(() => {
          this.positionCountryPanel();
          this.scrollSelectedCountryIntoView();

          if (this.isMobileCountrySelector() && this.elements.close) {
            this.elements.close.focus({ preventScroll: true });
          }
        });
      }
    }

    onDocumentPointerDown(event) {
      if (this.elements.panel.hasAttribute('hidden') || this.contains(event.target)) return;
      this.hidePanel();
    }

    isMobileCountrySelector() {
      return Boolean(this.elements.search && window.matchMedia('(max-width: 749px)').matches);
    }

    startPanelPositionTracking() {
      window.addEventListener('resize', this.boundSchedulePanelPosition);

      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', this.boundSchedulePanelPosition);
        window.visualViewport.addEventListener('scroll', this.boundSchedulePanelPosition);
      }
    }

    stopPanelPositionTracking() {
      window.removeEventListener('resize', this.boundSchedulePanelPosition);

      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', this.boundSchedulePanelPosition);
        window.visualViewport.removeEventListener('scroll', this.boundSchedulePanelPosition);
      }

      if (this.panelPositionFrame) {
        cancelAnimationFrame(this.panelPositionFrame);
        this.panelPositionFrame = null;
      }

      this.elements.panel.style.removeProperty('--localization-panel-top');
      this.elements.panel.style.removeProperty('--localization-panel-left');
      this.elements.panel.style.removeProperty('--localization-panel-height');
      this.elements.panel.style.removeProperty('--localization-panel-width');
    }

    schedulePanelPosition() {
      if (this.panelPositionFrame) cancelAnimationFrame(this.panelPositionFrame);
      this.panelPositionFrame = requestAnimationFrame(() => {
        this.panelPositionFrame = null;
        this.positionCountryPanel();
      });
    }

    positionCountryPanel() {
      if (!this.isMobileCountrySelector() || this.elements.panel.hasAttribute('hidden')) {
        if (this.elements.backdrop) this.elements.backdrop.setAttribute('hidden', true);
        return;
      }

      const viewport = window.visualViewport;
      const viewportTop = viewport ? viewport.offsetTop : 0;
      const viewportLeft = viewport ? viewport.offsetLeft : 0;
      const viewportHeight = viewport ? viewport.height : window.innerHeight;
      const viewportWidth = viewport ? viewport.width : window.innerWidth;
      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
      const previewBar = document.getElementById('PBarNextFrame');
      const viewportBottom = viewportTop + viewportHeight;
      const previewBarRect = previewBar ? previewBar.getBoundingClientRect() : null;
      const previewBarIsBottomToolbar = previewBarRect
        && previewBarRect.height > 0
        && previewBarRect.height <= Math.min(120, viewportHeight * 0.25)
        && previewBarRect.bottom >= viewportBottom - 4
        && previewBarRect.top < viewportBottom;
      const previewBarOverlap = previewBarIsBottomToolbar
        ? Math.max(0, Math.min(viewportBottom, previewBarRect.bottom) - Math.max(viewportTop, previewBarRect.top))
        : 0;
      const topClearance = 8;
      const bottomClearance = Math.max(8, previewBarOverlap + 8);
      const availableHeight = Math.max(120, viewportHeight - topClearance - bottomClearance);
      const panelHeight = Math.min(36.8 * rootFontSize, availableHeight);
      const panelWidth = Math.min(48 * rootFontSize, Math.max(160, viewportWidth - 16));
      const panelTop = viewportTop + Math.max(topClearance, viewportHeight - panelHeight - bottomClearance);
      const panelLeft = viewportLeft + (viewportWidth / 2);

      this.elements.panel.style.setProperty('--localization-panel-top', `${panelTop}px`);
      this.elements.panel.style.setProperty('--localization-panel-left', `${panelLeft}px`);
      this.elements.panel.style.setProperty('--localization-panel-height', `${panelHeight}px`);
      this.elements.panel.style.setProperty('--localization-panel-width', `${panelWidth}px`);

      if (this.elements.backdrop) this.elements.backdrop.removeAttribute('hidden');
    }

    scrollSelectedCountryIntoView() {
      if (!this.elements.countryList) return;

      const selected = this.elements.countryList.querySelector('[aria-current="true"]');
      if (!selected) {
        this.elements.countryList.scrollTop = 0;
        return;
      }

      const selectedItem = selected.closest('[data-country-option]');
      if (!selectedItem) return;

      const listRect = this.elements.countryList.getBoundingClientRect();
      const selectedRect = selectedItem.getBoundingClientRect();
      const selectedOffset = (selectedRect.top - listRect.top) + this.elements.countryList.scrollTop;
      const centeredOffset = selectedOffset
        - ((this.elements.countryList.clientHeight - selectedItem.offsetHeight) / 2);
      this.elements.countryList.scrollTop = Math.max(0, centeredOffset);
    }

    onPanelKeyDown(event) {
      if (event.key === 'Tab' && this.isMobileCountrySelector()) {
        const focusable = [
          this.elements.close,
          this.elements.search,
          ...Array.from(this.elements.panel.querySelectorAll('[data-country-option]:not([hidden]) a')),
        ].filter((element) => element && element.offsetParent !== null);

        if (focusable.length === 0) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
        return;
      }

      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;

      const linkSelector = this.elements.search
        ? '[data-country-option]:not([hidden]) a'
        : 'a';
      const links = Array.from(this.elements.panel.querySelectorAll(linkSelector));
      if (links.length === 0) return;

      if (document.activeElement === this.elements.search) {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        links[0].focus();
        return;
      }

      const currentIndex = links.indexOf(document.activeElement);
      let nextIndex = currentIndex;

      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = links.length - 1;
      if (event.key === 'ArrowDown') nextIndex = Math.min(currentIndex + 1, links.length - 1);
      if (event.key === 'ArrowUp' && currentIndex <= 0 && this.elements.search) {
        event.preventDefault();
        this.elements.search.focus();
        return;
      }
      if (event.key === 'ArrowUp') nextIndex = Math.max(0, currentIndex - 1);

      event.preventDefault();
      links[nextIndex].focus();
    }

    disconnectedCallback() {
      if (!this.elements) return;
      document.removeEventListener('pointerdown', this.boundOnDocumentPointerDown, true);
      this.stopPanelPositionTracking();
      if (!this.elements.panel.hasAttribute('hidden')) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      } 


      this.currentScrollTop = scrollTop;
    }

    hide() {
      /*this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();*/
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
        
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  function initialiseHeroSlider() {
    var heroSlider = document.querySelector(".hero-slider");
    if (!heroSlider || typeof window.Swiper !== "function") return;

    new Swiper(heroSlider.querySelector(".swiper"), {
    // spaceBetween: 50,
    // pagination: {
    //   el: ".swiper-pagination",
    //   clickable: true,
    // },
    observer: true,
    // autoheight: true,
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    // mousewheel: true,
    rewind: true,
    // loop: true,
    autoheight: true,
    speed: 2000,
    spaceBetween: 0,
    scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
          draggable: true,
    },
    autoplay: {
      delay: 6000,
      // disableOnInteraction: false,
      // pauseOnMouseEnter: true
    },
    keyboard: {
        enabled: true,
        onlyInViewport: false,
    },
    grabCursor: true
  });

    new Swiper(".mySwiper2", {
    // direction: "vertical",
    // spaceBetween: 50,
    // pagination: {
    //   el: ".swiper-pagination",
    //   clickable: true,
    // },
    observer: true,
    // keyboard: {
    //   enabled: true,
    //   onlyInViewport: false,
    // },
    // mousewheel: true,
    rewind: true,
    autoheight: true,
    effect: 'fade',
    // nested: true,
    autoplay: {
      delay: 2500,
      // disableOnInteraction: false,
      // pauseOnMouseEnter: true
    },
    speed: 2000,
    noSwiping: true,
    allowTouchMove: false
  });


  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialiseHeroSlider, { once: true });
  } else {
    initialiseHeroSlider();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!window.remassCollectionLoadMoreInitialised) {
    window.remassCollectionLoadMoreInitialised = true;

    let loadMoreObserver;
    let refreshScheduled = false;

    const historicalDateSort = {
      activeState: null,
      cache: new Map(),
      version: 0,

      isDateSort(sortBy) {
        return sortBy === 'created-ascending' || sortBy === 'created-descending';
      },

      itemDate(item) {
        const value = item.dataset.productEffectiveCreatedAt || item.dataset.productCreatedAt;
        const parsed = Date.parse(value || '');
        return Number.isNaN(parsed) ? 0 : parsed;
      },

      itemNativeDate(item) {
        const parsed = Date.parse(item.dataset.productCreatedAt || '');
        return Number.isNaN(parsed) ? 0 : parsed;
      },

      itemCollections(item) {
        try {
          const value = JSON.parse(item.dataset.originalCollectionHandles || '[]');
          return Array.isArray(value) ? value : [];
        } catch (error) {
          return [];
        }
      },

      sourceParams() {
        const params = new URLSearchParams();

        new URLSearchParams(window.location.search).forEach((value, key) => {
          if (key.startsWith('filter.')) params.append(key, value);
        });

        params.set('sort_by', 'title-ascending');
        params.set('page', '1');
        return params;
      },

      async fetchDocument(url) {
        const response = await fetch(url, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!response.ok) {
          throw new Error(`Historical date source request failed with status ${response.status}`);
        }

        return new DOMParser().parseFromString(await response.text(), 'text/html');
      },

      async sourceHtml(grid) {
        const sourceUrl = grid.dataset.historicalSortSourceUrl;
        const params = this.sourceParams();
        const cacheKey = `${sourceUrl}?${params.toString()}`;

        if (this.cache.has(cacheKey)) return this.cache.get(cacheKey);

        const firstUrl = `${sourceUrl}?${params.toString()}`;
        const firstDocument = await this.fetchDocument(firstUrl);
        const firstGrid = firstDocument.getElementById('product-grid');

        if (!firstGrid) {
          throw new Error('Historical date source did not contain a product grid');
        }

        const productCount = Number.parseInt(firstGrid.dataset.productCount || '0', 10);
        const productsPerPage = Number.parseInt(firstGrid.dataset.productsPerPage || '1', 10);
        const pageCount = Math.max(1, Math.ceil(productCount / Math.max(productsPerPage, 1)));
        const documents = [firstDocument];
        const sectionId = firstGrid.dataset.id;
        const pageRequests = [];

        for (let page = 2; page <= pageCount; page += 1) {
          const pageParams = new URLSearchParams(params);
          pageParams.set('section_id', sectionId);
          pageParams.set('page', String(page));
          pageRequests.push(this.fetchDocument(`${sourceUrl}?${pageParams.toString()}`));
        }

        documents.push(...(await Promise.all(pageRequests)));

        const items = documents.flatMap((documentNode) =>
          Array.from(
            documentNode.querySelectorAll('#product-grid > .grid__item__collection-product')
          )
        );
        const source = {
          allHtml: items.map((item) => item.outerHTML),
          migrationHtml: items
            .filter((item) => item.dataset.migrationProduct === 'true')
            .map((item) => item.outerHTML)
        };

        this.cache.set(cacheKey, source);
        return source;
      },

      createItem(html) {
        const template = document.createElement('template');
        template.innerHTML = html.trim();
        return template.content.firstElementChild;
      },

      sortItems(items, direction) {
        const multiplier = direction === 'ascending' ? 1 : -1;

        return items.sort((left, right) => {
          const dateDifference = this.itemDate(left) - this.itemDate(right);
          if (dateDifference !== 0) return dateDifference * multiplier;
          return (left.dataset.productId || '').localeCompare(right.dataset.productId || '') * multiplier;
        });
      },

      appendPage(items, hasNextPage) {
        const state = this.activeState;

        if (!state || !state.grid.isConnected) return null;

        const normalItems = [];

        items.forEach((item) => {
          const isReplacement = item.dataset.migrationProduct === 'true';
          const hasSourceReplacement = state.sourceProductIds.has(item.dataset.productId);

          if (!isReplacement || !hasSourceReplacement) normalItems.push(item);
        });

        let eligible = [];

        if (!hasNextPage) {
          eligible = state.pending.splice(0);
        } else if (normalItems.length) {
          const nativeDates = normalItems.map((item) => this.itemNativeDate(item));
          const boundary = state.direction === 'ascending'
            ? Math.max(...nativeDates)
            : Math.min(...nativeDates);

          eligible = state.pending.filter((item) => {
            const date = this.itemDate(item);
            return state.direction === 'ascending' ? date <= boundary : date >= boundary;
          });

          const eligibleIds = new Set(eligible.map((item) => item.dataset.productId));
          state.pending = state.pending.filter((item) => !eligibleIds.has(item.dataset.productId));
        }

        const combined = this.sortItems([...normalItems, ...eligible], state.direction);
        if (!state.rendered && !combined.length) return 0;

        if (!state.rendered) {
          state.grid.replaceChildren();
          state.rendered = true;
        }

        const fragment = document.createDocumentFragment();
        combined.forEach((item) => fragment.appendChild(item));
        state.grid.appendChild(fragment);
        return combined.length;
      },

      queueNextPage(button) {
        const state = this.activeState;

        if (!state || state.rendered || !button || !button.isConnected || !button.dataset.nextPageUrl) {
          return;
        }

        window.setTimeout(() => {
          if (
            state === this.activeState &&
            !state.rendered &&
            button.isConnected &&
            button.dataset.loading !== 'true' &&
            !button.disabled
          ) {
            button.click();
          }
        }, 0);
      },

      async initialise() {
        const grid = document.getElementById('product-grid');

        if (!grid || grid.dataset.historicalDateSortState) return;

        const sortBy = grid.dataset.sortBy;

        if (!this.isDateSort(sortBy)) {
          this.activeState = null;
          return;
        }

        const version = ++this.version;
        const direction = sortBy === 'created-ascending' ? 'ascending' : 'descending';
        const collectionHandle = grid.dataset.collectionHandle;
        const initialItems = Array.from(
          grid.querySelectorAll(':scope > .grid__item__collection-product')
        );
        const wrapper = grid.closest('.collection');
        const button = wrapper ? wrapper.querySelector('[data-load-more-button]') : null;
        const hasNextPage = Boolean(button && button.dataset.nextPageUrl);

        grid.dataset.historicalDateSortState = 'loading';
        grid.setAttribute('aria-busy', 'true');

        if (button) {
          button.dataset.historicalSortLoading = 'true';
          button.disabled = true;
        }

        try {
          const source = await this.sourceHtml(grid);
          const sourceItems = source.migrationHtml
            .map((html) => this.createItem(html))
            .filter((item) => item && this.itemCollections(item).includes(collectionHandle));

          if (version !== this.version || !grid.isConnected) return;

          if (collectionHandle === grid.dataset.historicalSortSourceHandle) {
            const allItems = source.allHtml
              .map((html) => this.createItem(html))
              .filter(Boolean);
            const fragment = document.createDocumentFragment();

            this.sortItems(allItems, direction).forEach((item) => fragment.appendChild(item));
            grid.replaceChildren(fragment);
            this.activeState = null;
            grid.dataset.historicalDateSortState = 'ready';

            const loadMore = wrapper ? wrapper.querySelector('.collection-load-more') : null;
            if (loadMore) loadMore.remove();
            return;
          }

          const sourceProductIds = new Set(sourceItems.map((item) => item.dataset.productId));
          this.activeState = {
            grid,
            direction,
            pending: this.sortItems(sourceItems, direction),
            sourceProductIds,
            rendered: false
          };

          this.appendPage(initialItems, hasNextPage);
          grid.dataset.historicalDateSortState = 'ready';
        } catch (error) {
          console.error('[Remass historical date sort]', error);
          grid.dataset.historicalDateSortState = 'failed';
          this.activeState = null;
        } finally {
          if (grid.isConnected) grid.removeAttribute('aria-busy');

          if (button && button.isConnected) {
            delete button.dataset.historicalSortLoading;
            button.disabled = false;
          }

          this.queueNextPage(button);
          scheduleRefresh();
        }
      }
    };

    const removeLegacyPagination = () => {
      document
        .querySelectorAll('.collection-grid-section .pagination-wrapper, #ProductGridContainer .pagination-wrapper')
        .forEach((pagination) => pagination.remove());
    };

    const observeLoadMoreButtons = () => {
      if (!('IntersectionObserver' in window)) return;

      if (!loadMoreObserver) {
        loadMoreObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              const button = entry.target;

              if (!button.isConnected) {
                loadMoreObserver.unobserve(button);
                return;
              }

              if (
                button.dataset.loading === 'true' ||
                button.dataset.autoLoadPaused === 'true' ||
                button.dataset.historicalSortLoading === 'true' ||
                button.disabled
              ) {
                return;
              }

              loadMoreObserver.unobserve(button);
              button.click();
            });
          },
          {
            root: null,
            rootMargin: '0px 0px 800px 0px',
            threshold: 0
          }
        );
      }

      document.querySelectorAll('[data-load-more-button]').forEach((button) => {
        if (
          !button.isConnected ||
          button.dataset.loading === 'true' ||
          button.dataset.autoLoadPaused === 'true' ||
          button.dataset.historicalSortLoading === 'true' ||
          button.disabled
        ) {
          return;
        }

        loadMoreObserver.observe(button);
      });
    };

    const refreshCollectionLoader = () => {
      removeLegacyPagination();
      historicalDateSort.initialise();
      observeLoadMoreButtons();
    };

    const scheduleRefresh = () => {
      if (refreshScheduled) return;

      refreshScheduled = true;

      window.requestAnimationFrame(() => {
        refreshScheduled = false;
        refreshCollectionLoader();
      });
    };

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-load-more-button]');

      if (
        !button ||
        button.dataset.loading === 'true' ||
        button.dataset.historicalSortLoading === 'true'
      ) {
        return;
      }

      const nextPageUrl = button.dataset.nextPageUrl;

      if (!nextPageUrl) return;

      const wrapper = button.closest('.collection-load-more');
      const status = wrapper ? wrapper.querySelector('[data-load-more-status]') : null;
      const productGrid = document.getElementById('product-grid');

      if (!productGrid) return;

      if (loadMoreObserver) loadMoreObserver.unobserve(button);

      button.dataset.autoLoadPaused = 'false';
      button.dataset.loading = 'true';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = button.dataset.loadingText;

      try {
        const response = await fetch(nextPageUrl, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!response.ok) {
          throw new Error(`Collection request failed with status ${response.status}`);
        }

        const responseText = await response.text();
        const nextDocument = new DOMParser().parseFromString(responseText, 'text/html');
        const newItems = Array.from(
          nextDocument.querySelectorAll('#product-grid > .grid__item__collection-product')
        );

        if (!newItems.length) {
          throw new Error('Collection response did not contain product cards');
        }

        if (!productGrid.isConnected) return;

        const nextButton = nextDocument.querySelector('[data-load-more-button]');
        const hasNextPage = Boolean(nextButton && nextButton.dataset.nextPageUrl);
        const historicallySortedCount = historicalDateSort.appendPage(newItems, hasNextPage);

        if (historicallySortedCount === null) {
          const fragment = document.createDocumentFragment();
          newItems.forEach((item) => fragment.appendChild(item));
          productGrid.appendChild(fragment);
        }

        if (status) {
          const visibleCount = historicallySortedCount === null ? newItems.length : historicallySortedCount;
          status.textContent = `${visibleCount} ${button.dataset.loadedText}`;
        }

        if (hasNextPage) {
          button.dataset.nextPageUrl = nextButton.dataset.nextPageUrl;
          button.disabled = false;
          button.textContent = button.dataset.defaultText;
        } else if (wrapper) {
          wrapper.remove();
        }
      } catch (error) {
        console.error('[Remass collection load more]', error);

        button.dataset.autoLoadPaused = 'true';
        button.disabled = false;
        button.textContent = button.dataset.defaultText;

        if (status) status.textContent = button.dataset.errorText;
      } finally {
        button.dataset.loading = 'false';
        button.removeAttribute('aria-busy');
        historicalDateSort.queueNextPage(button);
        scheduleRefresh();
      }
    });

    const collectionMutationObserver = new MutationObserver(() => {
      scheduleRefresh();
    });

    collectionMutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    refreshCollectionLoader();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-slider"] && !Shopify.designMode) return;
  try {
    
  function initialiseMultiSlider() {
    if (typeof window.Swiper !== "function") return;
    var swiper = new Swiper(".mySwiper", {
    // spaceBetween: 50,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    observer: true,
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    mousewheel: true,
    rewind: true,
    autoheight: true,
    speed: 400,
    // spaceBetween: 100,

  });
    new Swiper(".mySwiper2", {
    direction: "vertical",
    // spaceBetween: 50,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    observer: true,
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    mousewheel: true,
    rewind: true,
    autoheight: true,
    // speed: 400,
    spaceBetween: 100,
  });
  // const rotateButton = document.querySelector(".rotate-button");
  // rotateButton.addEventListener("click", () => {
  //   rotateButton.closest(".swiper-slide").classList.toggle("rotate");
  // });

    document.querySelectorAll(".icon-arrow-heart").forEach(element => {
      element.addEventListener("click", () => {
        swiper.slideNext(4000, true);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialiseMultiSlider, { once: true });
  } else {
    initialiseMultiSlider();
  }

  } catch(e) { console.error(e); }
})();
})();
